import {Injectable} from '@angular/core';
import {AngularFirestore, AngularFirestoreDocument} from '@angular/fire/compat/firestore';
import {Push} from '../models/push';
import {Observable} from 'rxjs';
import {Event} from '../models/event';
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PushService {

  private itemDoc: AngularFirestoreDocument<Push>;
  private item: Observable<Push>;
  public selectPushType: any;
  public eventArray: any[] = [];

  constructor (private db: AngularFirestore,
    public _authService: AuthService) { }

  select () {
    return this.db.collection<Push>('sbccv_pushes', ref => ref.orderBy('date_to_send', 'desc')).snapshotChanges();
  }

  selectByEvent (event_id) {
    return this.db.collection<Push>('sbccv_pushes', ref => ref.where('event_id', '==', event_id)).snapshotChanges();
  }

  selectById (id) {
    this.itemDoc = this.db.doc<Push>('sbccv_pushes/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }


  insert (push: Push) {
    delete push.id
    return this.db.collection('sbccv_pushes').add(Object.assign({}, push))
  }

  async getProductItens (event_id: any) {
    const result = await this.db.collection<Push>('sbccv_product_itens', ref => ref
      .where('event_id', '==', event_id))
      .get()
      .toPromise();

    const array: any[] = [];
    result.forEach((item) => {
      array.push({"id": item.id, ...item.data()});
    })

    return array
  }

  update (push: Push) {
    let id = push.id
    delete push.id
    return this.db.collection('sbccv_pushes').doc(id).set(Object.assign({}, push))
  }

  delete (push_id: any) {
    return this.db.collection('sbccv_pushes').doc(push_id).delete();
  }


  loadEvent () {
    this.db.collection<Event>('sbccv_events', ref => ref
      .orderBy('name', 'asc')).snapshotChanges()
      .subscribe((result) => {

        this.eventArray = result.map(item => {

          return {
            id: item.payload.doc.id,
            name: item.payload.doc.data().name
          };

        });
      })
  }


}
